import { jsx as a, jsxs as f, Fragment as r } from "react/jsx-runtime";
import m, { forwardRef as _, useId as y, isValidElement as p, cloneElement as v } from "react";
import { c as n } from "./clsx-OuTLNxxd.js";
import { a as u } from "./Tooltip-Db471qlE.js";
import './Table.css';const W = "320px", H = "600px", q = "1025px", z = "_tableGroup_fqfv4_32", w = "_table_fqfv4_32", C = "_tableLabel_fqfv4_46", S = "_tableWrapper_fqfv4_64", B = "_tableCaption_fqfv4_82", T = "_tableRow_fqfv4_99", N = "_tableHeader_fqfv4_103", R = "_tableColumn_fqfv4_103", F = "_tableBody_fqfv4_113", D = "_tableCell_fqfv4_113", G = "_tableFooter_fqfv4_115", I = "_highlight_fqfv4_135", j = "_showDividers_fqfv4_169", k = "_cellWrapper_fqfv4_205", L = "_headingText_fqfv4_132", $ = "_columnWrapper_fqfv4_208", e = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: W,
  "mobile-wide": "480px",
  tablet: H,
  "tablet-wide": "800px",
  desktop: q,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  tableGroup: z,
  table: w,
  tableLabel: C,
  tableWrapper: S,
  tableCaption: B,
  tableRow: T,
  tableHeader: N,
  "tableRow-size--s": "_tableRow-size--s_fqfv4_103",
  tableColumn: R,
  "tableRow-size--m": "_tableRow-size--m_fqfv4_107",
  tableBody: F,
  tableCell: D,
  tableFooter: G,
  "headingText--mobile": "_headingText--mobile_fqfv4_132",
  highlight: I,
  showDividers: j,
  "highlight--green": "_highlight--green_fqfv4_188",
  "highlight--amber": "_highlight--amber_fqfv4_192",
  "highlight--red": "_highlight--red_fqfv4_196",
  "mobile-hide": "_mobile-hide_fqfv4_200",
  cellWrapper: k,
  headingText: L,
  columnWrapper: $
}, K = ({ children: i, className: t, row: l, ...o }) => /* @__PURE__ */ a("thead", { className: n(e.tableHeader, t), style: { "--gridRow": l }, ...o, children: i }), M = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("tbody", { className: n(e.tableBody, t), ...l, children: i }), O = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("tfoot", { className: n(e.tableFooter, t), ...l, children: i }), P = ({ children: i, className: t, size: l = "m", ...o }) => /* @__PURE__ */ a("tr", { className: n(e.tableRow, e[`tableRow-size--${l}`], t), ...o, children: i }), Q = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("caption", { className: n(e.tableCaption, t), ...l, children: i }), U = ({
  alignItems: i = "center",
  children: t,
  className: l,
  highlight: o,
  justifyContent: c = "flex-start",
  mobileText: s,
  mobileView: x,
  showDividers: h,
  toolTipSide: g,
  tooltipText: b,
  ...d
}) => /* @__PURE__ */ a(
  "th",
  {
    className: n(
      e.tableColumn,
      e[`mobile-${x}`],
      {
        [e.highlight]: o,
        [e.showDividers]: h
      },
      l
    ),
    ...d,
    children: /* @__PURE__ */ f(
      "div",
      {
        className: e.columnWrapper,
        style: {
          "--alignItems": i,
          "--justifyContent": c
        },
        children: [
          s ? /* @__PURE__ */ f(r, { children: [
            /* @__PURE__ */ a("span", { className: e["headingText--mobile"], children: s }),
            /* @__PURE__ */ a("span", { className: e.headingText, children: t })
          ] }) : /* @__PURE__ */ a(r, { children: t }),
          b && /* @__PURE__ */ a(u, { side: g, children: b })
        ]
      }
    )
  }
), X = ({
  alignItems: i = "center",
  children: t,
  className: l,
  highlight: o,
  justifyContent: c = "flex-start",
  showDividers: s,
  style: x,
  ...h
}) => /* @__PURE__ */ a(
  "td",
  {
    className: n(
      e.tableCell,
      {
        [e.highlight]: o,
        [e[`highlight--${o}`]]: o,
        [e.showDividers]: s
      },
      l
    ),
    style: {
      ...x,
      "--alignItems": c,
      "--justifyContent": i
    },
    ...h,
    children: /* @__PURE__ */ a("div", { className: e.cellWrapper, children: t })
  }
), Y = _(({ children: i, className: t, ...l }, o) => /* @__PURE__ */ a("div", { className: e.tableWrapper, "data-cxy-name": "table", children: /* @__PURE__ */ a("table", { className: n(e.table, t), ref: o, ...l, children: i }) })), Z = ({ children: i, className: t, label: l }) => {
  const o = y(), c = m.Children.map(
    i,
    (s) => p(s) ? v(s, {
      "aria-labelledby": o
    }) : s
  );
  return /* @__PURE__ */ f("div", { className: n(e.tableGroup, t), children: [
    l && /* @__PURE__ */ a("h3", { className: e.tableLabel, id: o, children: l }),
    c
  ] });
};
export {
  Y as T,
  M as a,
  Q as b,
  X as c,
  U as d,
  O as e,
  Z as f,
  K as g,
  P as h
};
